import { render, staticRenderFns } from "./ConteudoTexto.vue?vue&type=template&id=365b2be8&scoped=true&"
import script from "./ConteudoTexto.vue?vue&type=script&lang=js&"
export * from "./ConteudoTexto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365b2be8",
  null
  
)

export default component.exports